import { render, staticRenderFns } from "./bonusRatioList.vue?vue&type=template&id=21dd736a&scoped=true"
import script from "./bonusRatioList.vue?vue&type=script&lang=js"
export * from "./bonusRatioList.vue?vue&type=script&lang=js"
import style0 from "./bonusRatioList.vue?vue&type=style&index=0&id=21dd736a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dd736a",
  null
  
)

export default component.exports